"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.auto.turn.detection': 'Automatyczne wykrywanie tury',
    'conversation.auto.turn.detection.help': 'Automatycznie zatrzymuj nagrywanie gdy zostanie wykryta cisza',
};
